import { Component, Vue } from 'vue-property-decorator';
import UserService from '@/services/user.service';
import InputPassword from '@/components/inputs/InputPassword/InputPassword';
import LocalStoreService from '@/store/local.store';


@Component({
  components: {
    InputPassword,
  },
})
export default class PasswordModification extends Vue {
  // Properties
  public errorMessage: string = '';
  public successMessage: string = '';
  private userName: string =  '';
  private oldPassword: string = '';
  private newPassword: string = '';
  private repeatNewPassword: string = '';

  // Lifecycle hook
  public mounted() {
    this.userName = LocalStoreService.getItem(LocalStoreService.localItemKeys.proUsername) || '';
  }

  // Methods

  /**
   * Saves the newly entered password.
   */
  protected async saveNewPassword() {
    this.errorMessage = '';

    if (this.newPassword !== this.repeatNewPassword) {
      this.errorMessage = 'errorMgs.password.newPasswordsNotMatching'; // translation key
      return;
    }

    await UserService.saveNewPassword(this.userName, this.oldPassword, this.newPassword)
      .then(() => {
        this.successMessage = 'password.successfullyChanged';
      })
      .catch((error: any) => {

        if (error.response === undefined) {
          return;
        }

        switch (error.response.status) {
          case 401:
            this.errorMessage = 'errorMgs.password.oldPasswordNotMatching'; // translation key
            break;
          case 404:
            this.errorMessage = 'errorMgs.password.usernameUnknown'; // translation key
            break;
          default:
            this.errorMessage = 'errorMgs.password.savingPasswordError'; // translation key
        }
      });
  }

}
